export default "__VITE_ASSET__CpWuqq9E__"